import moment from 'moment-timezone';
import React, { useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import ReactDatePicker from 'react-datepicker';

export const OwnerLastContactModal = ({
  showModal,
  ownerContactDate,
  setOwnerContactDate,
  ownerContactDateError,
  setOwnerContactDateError,
  setNoteText,
  noteText,
  noteTextError,
  setNoteTextError,
  disabled,
  updateOwnerLastContact,
  setShowModal,
}) => {
  useEffect(() => {
    if (showModal) {
      setOwnerContactDate(moment().toDate());
    }
  }, [showModal, setOwnerContactDate]);

  return (
    <>
      <Modal show={showModal} backdrop="static" centered dialogClassName="property-modal">
        <Modal.Header
        title="Owner Last Contact"
          closeButton
          onClick={() => {
            setShowModal(false);
          }}
        >
          <Modal.Title><span className='font-weight-bold'>Owner Last Contact</span></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <label className="form-label mb-2 mt-2">
            Owner Last Contact Date:
          </label>
          <ReactDatePicker 
            selected={ownerContactDate} 
            onChange={(date) => setOwnerContactDate(date)}
            dateFormat="dd/MM/yyyy"
            maxDate={moment().toDate()}
            placeholderText="Date"
            customInput={
            <input
              autoComplete="off"
              className={`form-control d-block w-100 mb-2`}
              type="text"
              />} 
            />
          {ownerContactDateError && (
            <small className="text-danger">{ownerContactDateError}</small>
          )}
          <label
            className="form-label block mb-2 mt-2"
            htmlFor="NoteText"
          >
            Comments:
          </label>
          <input
            id="NoteText"
            autoComplete="off"
            className={`form-control d-block w-100 ${
              noteTextError && 'border-danger'
            }`}
            type="text"
            value={noteText}
            onChange={(event) => {
              setNoteTextError('');
              setNoteText(event.target.value);
            }}
            name="comment"
            required
          />
          {noteTextError && (
            <small className="text-danger">{noteTextError}</small>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant={
              ownerContactDate !== null && disabled === true
                ? 'success'
                : 'primary'
            }
            onClick={(event) => updateOwnerLastContact(event)}
            disabled={ownerContactDate !== null && disabled === true}
          >
            {ownerContactDate !== null && disabled === true
              ? 'Saving...'
              : 'Save'}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
